import React from 'react';
import { CommonIconProps } from './Icon';

const ClearIcon = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM8.6636 8.66362C9.01508 8.31215 9.58492 8.31215 9.9364 8.66362L12 10.7272L14.0636 8.66362C14.4151 8.31215 14.9849 8.31215 15.3364 8.66362C15.6879 9.0151 15.6879 9.58494 15.3364 9.93642L13.2728 12L15.3364 14.0636C15.6879 14.4151 15.6879 14.9849 15.3364 15.3364C14.9849 15.6879 14.4151 15.6879 14.0636 15.3364L12 13.2728L9.9364 15.3364C9.58492 15.6879 9.01508 15.6879 8.6636 15.3364C8.31213 14.9849 8.31213 14.4151 8.6636 14.0636L10.7272 12L8.6636 9.93642C8.31213 9.58494 8.31213 9.0151 8.6636 8.66362Z"
      fill={color}
    />
  </>
);

export default ClearIcon;
